// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 2H2V6.5H4.00368V8.5H2V11H4.00368V13H2V15.5H4.00368V17.5H2V22H6.5V20.0326H8.5V22H11V20.0326H13V22H15.5V20.0326H17.5V22H22V12H12V2Z"}}]};

const Measurement1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'measurement-1-filled',
    ref,
    icon: element,
  },
));

Measurement1FilledIcon.displayName = 'Measurement1FilledIcon';

export default Measurement1FilledIcon;
